import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FaseEstado } from '../../_models/fase-estado';
import { Rol } from '../../_models/rol';
import { Estado } from '../../_models/estado';
import { FaseEstadoRol } from '../../_models/fase-estado-rol';
import { FaseEstadoRolService } from '../../_services/fase-estado-rol.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Fase } from '../../_models/fase';
import { FaseEstadoService } from '../../_services/fase-estado.service';

@Component( {
  selector: 'app-fase-estado-editar',
  templateUrl: 'fase-estado-editar.component.html'
} )

export class FaseEstadoEditarComponent implements OnInit {

  @Input() fasEstado: FaseEstado;
  @Input() fase: Fase;
  @Input() lisFaseEstado: FaseEstado[] = [];
  @Input() lisRoles: Rol[] = [];
  @Input() lisEstados: Estado[] = [];
  @Input() lisFaseEstadoRolTodos: FaseEstadoRol[] = [];
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
  formulario: FormGroup;
  forRol: FormGroup;
  submitted = false;
  subRol = false;
  cargando = true;
  lisFaseEstadoRol: FaseEstadoRol[] = [];
  lisEstadosDrop: SelectItem[] = [];
  lisRolDrop: SelectItem[] = [];
  columnas: any[] = [];

  constructor( private fasEstadoRolServicio: FaseEstadoRolService,
               private fb: FormBuilder,
               private fasEstadoServicio: FaseEstadoService,
               private navServicio: NavService, private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'rol', header: this.navServicio.buscarMensaje( 'FASES.LBL_ROL' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.cargarFormulario();
    this.cargarEstados();
    if ( this.fasEstado ) {
      this.cargarRolesHabilitados();
      this.cargarRoles();
    }
    this.cargando = false;
  }

  cargarRolesHabilitados() {
    this.lisFaseEstadoRol = this.lisFaseEstadoRolTodos.filter( x => x.indicadorHabilitado && x.idFaseEstado === this.fasEstado.idFaseEstado );
  }

  cargarFormulario() {
    this.forRol = this.fb.group( {
      idRol: [ null, [ Validators.required ] ]
    } );

    this.formulario = this.fb.group( {
      idFaseEstado: [ this.fasEstado ? this.fasEstado.idFaseEstado : null ],
      idFase: [ this.fasEstado ? this.fasEstado.idFase : this.fase.idFase ],
      idEstado: [ this.fasEstado ? this.fasEstado.idEstado : null, [ Validators.required ] ],
      indicadorDesembolso: [ this.fasEstado ? this.fasEstado.indicadorDesembolso : false ],
      indicadorHabilitado: [ this.fasEstado ? this.fasEstado.indicadorHabilitado : true ]
    } );
  }

  cargarEstados() {
    this.lisEstadosDrop = [];
    this.lisEstados.map( ( s: Estado ) => {
      if ( !this.lisFaseEstado.find( x => x.indicadorHabilitado && x.idEstado === s.idEstado ) && (!this.fase.indicadorInicial || s.indicadorEstadoInicial) ) {
        this.lisEstadosDrop.push( { label: s.nombre, value: s.idEstado } );
      }
    } );
  }

  cargarRoles() {
    this.lisRolDrop = [];
    this.lisRoles.map( ( s: Rol ) => {
      if ( !this.lisFaseEstadoRol.find( x => x.idRol === s.idRol ) ) {
        this.lisRolDrop.push( { label: s.nombre, value: s.idRol } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get fRoles() {
    return this.forRol.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.cargando = true;
      const registro = this.formulario.value;
      if ( registro.idFaseEstado ) {
        this.fasEstadoServicio.actualizar( registro ).subscribe( actualizado => {
          this.fasEstado.indicadorDesembolso = actualizado.indicadorDesembolso;
          this.formulario.markAsPristine();
          this.navServicio.setMesage( 2 );
          this.cargando = false;
        } );
      } else {
        const a = this.lisFaseEstado.find( x => x.idEstado === registro.idEstado );
        if ( a ) {
          a.indicadorDesembolso = registro.indicadorDesembolso;
          a.indicadorHabilitado = true;
          this.fasEstadoServicio.actualizar( a ).subscribe( actualizado => {
            this.fasEstado = a;
            this.f.idFaseEstado.setValue( a.idFaseEstado );
            this.navServicio.setMesage( 1 );
            this.formulario.markAsPristine();
            this.cargarRoles();
            this.cargarEstados();
            this.cargando = false;
          } );
        } else {
          this.fasEstadoServicio.crear( registro ).subscribe( creado => {
            registro.idFaseEstado = creado.idFaseEstado;
            registro.fase = this.fase.nombre;
            this.f.idFaseEstado.setValue( registro.idFaseEstado );
            const estado = this.lisEstados.find( x => x.idEstado === registro.idEstado );
            if ( estado ) {
              registro.estado = estado.nombre;
            }
            this.fasEstado = registro;
            this.lisFaseEstado.push( registro );
            this.navServicio.setMesage( 1 );
            this.formulario.markAsPristine();
            this.cargarEstados();
            this.cargarRoles();
            this.cargando = false;
          } );
        }
      }
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'fase-estado-editar',
        accept: () => {
          this.dismiss.emit( true );
        },
        reject: () => {
        }
      } );
    } else {
      this.dismiss.emit( true );
    }
  }

  onSubmitRoles() {
    this.subRol = true;
    if ( this.forRol.valid ) {
      this.cargando = true;
      const registro = this.forRol.value;
      const existe = this.lisFaseEstadoRolTodos.find( x => x.idRol == registro.idRol && x.idFaseEstado === this.fasEstado.idFaseEstado );
      if ( existe ) {
        existe.indicadorHabilitado = true;
        this.fasEstadoRolServicio.actualizar( existe ).subscribe( actualizo => {
          this.terminarRoles( 2 );
        } );
      } else {
        const a = {} as FaseEstadoRol;
        a.idRol = registro.idRol;
        a.idFaseEstado = this.fasEstado.idFaseEstado;
        a.indicadorHabilitado = true;
        this.fasEstadoRolServicio.crear( a ).subscribe( creado => {
          a.idFaseEstadoRol = creado.idFaseEstadoRol;
          const rol = this.lisRoles.find( x => x.idRol === a.idRol );
          if ( rol ) {
            a.rol = rol.nombre;
          }
          this.lisFaseEstadoRolTodos.push( a );
          this.terminarRoles( 1 );
        } );
      }
    }
  }

  terminarRoles( tipo: number ) {
    this.navServicio.setMesage( tipo );
    this.forRol.reset();
    this.subRol = false;
    this.cargarRolesHabilitados();
    this.cargarRoles();
    this.cargando = false;
  }

  inhabilitarRol( registro: FaseEstadoRol ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'fase-estado-editar',
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.fasEstadoRolServicio.actualizar( registro ).subscribe( regActualizado => {
          this.cargarRolesHabilitados();
          this.cargarRoles();
          this.navServicio.setMesage( 2 );
          this.cargando = false;
        } );
      },
      reject: () => {
      }
    } );
  }

}
